// Buying tokens needs a verified email and phone, like every other business admin tab.
export function canBuyTokens(user, hasPermission) {
  if (!user || !user.email_verified || !user.phone_number_verified) return false
  return !!user.is_primary || !!hasPermission('settings.billing.purchase')
}
